import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import { LockOpenIcon } from '../icons-library/lock-open';
import { StyledSignedInAs, StyledSignedInAsBold, StyledSignedInStatus } from '../login-menu/login-menu.styles';
import clsx from 'clsx';
import { StyledHeaderIcon } from '../header/header.style';

type UserControlsProps = {
    showLoginRegisterLabel?: boolean;
    usePadding?: boolean;
};

export const UserControls = (props: UserControlsProps) => {
    const {
        userState,
        localize,
        viewport,
        appStore,
        siteInfo,
    } = useContext(AppContext);
    const { openLoginMenu, close, openUserProfileMenu } = appStore;

    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;
    const isDesktop = () => !isMobile();
    const loggedIn = () => userState.user;
    const loggedOut = () => !loggedIn();

    const handleClickOpenLoginMenu = () => {
        close();

        if (userState.user) {
            openUserProfileMenu();
            return;
        }

        openLoginMenu();
    };

    const PadlockButton = () => (
        <StyledHeaderIcon>
            <button
                class={clsx({ 'py-[0.5rem] px-[1.43rem]': props.usePadding }, 'flex')}
                tabIndex={0}
                onClick={handleClickOpenLoginMenu}
                aria-label={localize('header_login_icon', 'Link to Login / Register')}
            >
                <LockOpenIcon
                    {...(viewport.width < theme.breakpoints.MOBILE
                        ? {
                            height: 2.5,
                            width: 2.5,
                            opacity: 0.7,
                        }
                        : {})}
                />
                <Show when={props.showLoginRegisterLabel}>
                    <span onClick={handleClickOpenLoginMenu}>
                        {localize('login-register', 'Login / Register')}
                    </span>
                </Show>
            </button>
        </StyledHeaderIcon>
    );

    return (
        <>
            <Show when={siteInfo.siteType === 'default'}>
                <Show when={loggedIn()}>
                    <Show when={isMobile()}>
                        <PadlockButton />
                    </Show>

                    <Show when={isDesktop()}>
                        <StyledHeaderIcon>
                            <StyledSignedInStatus title={userState.user?.email} usePadding={props?.usePadding ? props.usePadding : false}>
                                <StyledSignedInAs
                                    onClick={handleClickOpenLoginMenu}
                                    aria-label={userState.user 
                                        ? localize('open-user-profile-menu', 'Open user profile menu')
                                        : localize('open-login-menu', 'Open login menu')
                                    }
                                >
                                    <StyledSignedInAsBold class={clsx('pl-[8px]')}>{localize('signed-in-as', 'Signed in as')}</StyledSignedInAsBold>
                                    <div class={clsx('pl-[8px]')}>{userState.user?.firstName || userState.user?.email || ''}</div>
                                </StyledSignedInAs>
                            </StyledSignedInStatus>
                        </StyledHeaderIcon>
                    </Show>
                </Show>

                <Show when={loggedOut()}>
                    <Show when={appStore.isHcp()}>
                        <PadlockButton />
                    </Show>
                </Show>
            </Show>

            <Show when={siteInfo.siteType === 'atos-care'}>
                <Show when={loggedIn()}>
                    <Show when={isMobile()}>
                        <PadlockButton />
                    </Show>

                    <Show when={isDesktop()}>
                        <StyledHeaderIcon>
                            <StyledSignedInStatus title={userState.user?.email} usePadding={props?.usePadding ? props.usePadding : false}>
                                <StyledSignedInAs
                                    onClick={handleClickOpenLoginMenu}
                                    aria-label={userState.user
                                        ? localize('open-user-profile-menu', 'Open user profile menu')
                                        : localize('open-login-menu', 'Open login menu')}
                                >
                                    <StyledSignedInAsBold class={clsx('pl-[8px]')}>{localize('signed-in-as', 'Signed in as')}</StyledSignedInAsBold>
                                    <div class={clsx('pl-[8px]')}>{userState.user?.firstName || userState.user?.email || ''}</div>
                                </StyledSignedInAs>
                            </StyledSignedInStatus>
                        </StyledHeaderIcon>
                    </Show>
                </Show>

                <Show when={loggedOut()}>
                    <PadlockButton />
                </Show>
            </Show>
        </>
    );
};
